/* Поля формы инструмента: fields[] шаблона и screen_fields[] контракта экрана (docs/59-studio-backend-contracts.md §1).
   Контрол из спецификации ставится на форму, только если его поле опубликовано в одном из наборов или его включает
   флаг политики формы; отправляются только опубликованные ключи. */
import type { StudioForm } from '../studio-api';

export type ToolField = StudioForm['fields'][number] & {
  value_encoding?: 'string' | 'json';
  default_value?: unknown;
  max_length?: number;
};
export function screenFields(form: StudioForm | null | undefined): ToolField[] {
  const raw = (form as unknown as { screen_fields?: unknown } | null)?.screen_fields;
  return Array.isArray(raw)
    ? raw.filter(
        (item): item is ToolField =>
          !!item && typeof item === 'object' && typeof (item as ToolField).key === 'string' && /^[a-z][a-z0-9_]{0,63}$/.test((item as ToolField).key),
      ).map(item => ({ ...item, values: Array.isArray(item.values) ? item.values : [], upload: item.upload ?? null, required: !!item.required }))
    : [];
}
/** Все поля формы: сначала шаблона, затем контракта экрана (ключ шаблона главнее). */
export function toolFields(form: StudioForm | null | undefined): ToolField[] {
  if (!form) return [];
  const own = form.fields as ToolField[];
  const keys = new Set(own.map(field => field.key));
  return [...own, ...screenFields(form).filter(field => !keys.has(field.key))];
}
export function toolField(form: StudioForm | null | undefined, ...keys: string[]): ToolField | undefined {
  const fields = toolFields(form);
  for (const key of keys) {
    const found = fields.find(field => field.key === key);
    if (found) return found;
  }
  return undefined;
}
export const hasToolField = (form: StudioForm | null | undefined, ...keys: string[]) => !!toolField(form, ...keys);
/** Поле контракта экрана с JSON-значением: в inputs хранится JSON-строкой (общий хук формы держит строки). */
export const isJsonField = (field: ToolField | undefined) => field?.value_encoding === 'json';
/** Значение по умолчанию поля строкой, только из опубликованных значений. */
export function toolDefault(field: ToolField | undefined): string | undefined {
  if (!field) return undefined;
  const raw = field.default_value;
  if (raw === undefined || raw === null) return undefined;
  const value = typeof raw === 'string' ? raw : isJsonField(field) ? JSON.stringify(raw) : String(raw);
  return !field.values.length || field.values.includes(value) ? value : undefined;
}
/** Флаг политики формы (constraints.<policy>.<flag> === true). */
export function policyFlag(policy: Record<string, unknown> | null | undefined, flag: string) {
  return !!policy && policy[flag] === true;
}
